import React, { useEffect, useState } from 'react';
import KdsService from '../../services/KdsService';
import OrderCard from '../Orders/order-card';
import OrderService from '../../services/OrderService';
import { Pagination } from 'antd';

const CompletedOrders = () => {
    const [orderList, setOrderList] = useState('');
    const [page, setPage] = useState(1);

    const getAllOrder = () => {
        KdsService.getOrders(page).then((res)=>{
            setOrderList(res)
        });
    }
    useEffect(()=>{
        getAllOrder()
    },[page]);
    const onChangeExtraTime = async(e, id) => {
        await OrderService.updateTime({ order_num: id, extra_time_mins: e });
        getAllOrder();
      };
      const onPageChange = (e) => {
        setPage(e);
      };
    return <div className='w-full'>
            <div className="mt-2 pt-1 w-full">
          {orderList?.orders?.map(
            (order) => (
              <OrderCard
                key={order.id}
                order={order}
                acceptOrder={()=>{}}
                rejectOrder={()=>{}}
                onChangeExtraTime={onChangeExtraTime}
              />
            )
            // )
          )}
        </div>
        {orderList?.total > 10 && 
       <div className="text-right">
          <Pagination defaultCurrent={1} showSizeChanger={false} onChange={onPageChange} total={orderList?.total} />
       </div>}
    </div>
};
export default CompletedOrders;